var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-6 p-3",class:{'open': _vm.isMenuOpen},attrs:{"id":"buger-menu"},on:{"click":_vm.emitEvent}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }